import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import { Box, Stack, Typography } from "@mui/material";
import { useAppSelector } from "../../../redux/store";
import { StepperData } from "../../../types/common";
import getStepperLabels from "../../../utils/getStepperLabels";
import styles from "./styles";

const Stepper = () => {
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { stepperConfig, pageText, stepData }: any = customerJourney;
  const stepperLabels = getStepperLabels();

  return (
    <Box pt={5}>
      <Typography variant="h1">
        {pageText?.textMetadata.registerForCambridgeEsolExam}
      </Typography>
      {stepData?.value !== "paymentRedirect" && (
        <Stack
          mt={{ xs: 5, md: 11 }}
          gap={3}
          direction={{ md: "row" }}
          justifyContent={
            stepData?.value === "appliedSuccessful" ? "center" : "space-between"
          }
        >
          {stepData?.value !== "appliedSuccessful" && (
            <Box>
              <Typography variant="h6" component="p" fontWeight="700">
                {stepperLabels[stepData?.value]}
              </Typography>
              <Typography color="secondary.main">
                {pageText?.textMetadata?.step} <b>{stepData?.stepNumber}</b>{" "}
                {pageText?.textMetadata?.of} 5
              </Typography>
            </Box>
          )}
          <Stack
            direction="row"
            alignItems="center"
            maxWidth="512px"
            width={{ xs: "100%" }}
          >
            {stepperConfig.length &&
              stepperConfig?.map((item: StepperData, index: number) => {
                if (index < 5) {
                  return (
                    <React.Fragment key={item?.value}>
                      <Box
                        sx={{
                          ...styles.step,
                          ...(item?.selected ? styles.selectedStep : {}),
                          ...(item?.completed ? styles.completedStep : {}),
                        }}
                      >
                        {item?.completed ? <CheckIcon /> : item?.stepNumber}
                      </Box>
                      {index !== 4 && <Box sx={styles.stepLine}></Box>}
                    </React.Fragment>
                  );
                } else {
                  return <Box key={item?.value} />;
                }
              })}
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default Stepper;
